import { Buffer } from 'buffer'

// Cross-language fixtures pinned by diesel_refund_layout_fixture in the API.
// Mint DIESEL [2,0,77], then deposit in OWVault [2,92934,4]. The virtual
// deposit pointer changes with the FINAL transaction output count.
const scripts: Record<number, string> = {
	2: '6a5d1dff7f818ceca2d08bc0a88281d29590c0c12dff7fdd80c492c8d1b6d740',
	3: '6a5d1dff7f818cecaad08bc0a88281d29590c0c12dff7fdd80c492c8d1b6d740',
	4: '6a5d1dff7f818cecb2d08bc0a88281d29590c0c12dff7fdd80c492c8d1b6d740',
	5: '6a5d1dff7f818cecbad08bc0a88281d29590c0c12dff7fdd80c492c8d1b6d740'
}

export const OFFER_DIESEL_OUTPUT_VBYTES = 41

export function offerDieselScript(outputCount: number): Buffer {
	if (!scripts[outputCount]) throw new Error('Unsupported offer mint layout.')
	return Buffer.from(scripts[outputCount], 'hex')
}

/**
 * Settlement and refund templates the API builds end with the mint, so it
 * must be the last output there.
 */
export function hasOfferDieselMint(outputs: { value: number; script: Uint8Array }[]): boolean {
	const expected = scripts[outputs.length]
	const mint = outputs.at(-1)
	return !!expected && !!mint && mint.value === 0 &&
		Buffer.from(mint.script).toString('hex') === expected &&
		outputs.filter((output) => output.script[0] === 0x6a).length === 1
}

/**
 * The funding's mint may sit anywhere: the API asks the wallet for
 * `[escrow, mint]` and the coin selector appends change after the
 * recipients, so a funding with change is `[escrow, mint, change]` with the
 * pointer rewritten for the final count. Mirrors the API's
 * valid_offer_mint_outputs: exactly one OP_RETURN, worth nothing, carrying
 * the script for this output count.
 */
export function hasOfferFundingMint(outputs: { value: number; script: Uint8Array }[]): boolean {
	const expected = scripts[outputs.length]
	const mints = outputs.filter((output) => output.script[0] === 0x6a)
	return (
		!!expected &&
		mints.length === 1 &&
		mints[0].value === 0 &&
		Buffer.from(mints[0].script).toString('hex') === expected
	)
}
